module.exports = __webpack_public_path__ + "static/officeWorld-06658f646711fbf68b4693666b631a70.png";